module.exports = __webpack_public_path__ + "img/venueone-icon1.1cd463ee.png";